let recaptchaScript = null;

export function loadRecaptcha(sitekey) {
  if (!recaptchaScript) {
    recaptchaScript = document.createElement('script');
    recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${sitekey}`;
    recaptchaScript.async = true;
    document.body.appendChild(recaptchaScript);
  }
}